import seo from "./SEO.webp";
import ppc from "./PPC.webp";
import smo from "./SMM.webp";
import sem from "./SEM.webp";
import email from "./EM.webp";
import content from "./Content_Marketing.webp";
import branding from "./Branding.webp";

export const images = {
  hero: "https://images.unsplash.com/photo-1557838923-2985c318be48?auto=format&fit=crop&w=1400&q=80",
  services: {
    seo,
    ppc,
    smo,
    sem,
    email,
    content,
    branding,
  },
  highlights: {
    performance: null,
    webDev: null,
    brandStrategy: null,
  },
};